import { useState } from 'react';
import { QuestionSetClient, QuestionSetDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useQuestionSetApi = () => {
    const apiClient = new QuestionSetClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: QuestionSetDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createQuestionSet(data);
        } catch (err: any) {
            setError(err.message || 'Error creating QuestionSet');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: QuestionSetDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateQuestionSet(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating QuestionSet');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getQuestionSetById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching QuestionSet');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchQuestionSets(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching QuestionSets');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteQuestionSet(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting QuestionSet');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};